import { z } from "zod";

import { type CreateMaterialsVolumetricPriceDto } from "#modules/materials/infra/createMaterialsVolumetricPrice.api";
import { euroToCents, parseInputNumberValue } from "#shared/helpers/prices";
import { MaterialGradeSchema, MaterialGradeType } from "shared";

import { isValidEuroAmount } from "./isValidEuroAmount";

export const AddVolumetricMaterialFormSchema = z
  .object({
    materialGrade: MaterialGradeSchema.nullable().refine(
      (value): value is MaterialGradeType => value !== null,
    ),
    name: z.string().trim().min(1),
    price: z.string().refine(isValidEuroAmount),
  })
  .transform(
    (values): CreateMaterialsVolumetricPriceDto => ({
      materialGrade: values.materialGrade,
      name: values.name,
      volumetricPrice: euroToCents(parseInputNumberValue(values.price)),
    }),
  );

export type AddVolumetricMaterialFormValues = z.input<typeof AddVolumetricMaterialFormSchema>;
